import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IFormData, IFormError, UserInfo } from "../models";
import { RootState } from "./store";

export interface IFormDataState extends IFormData {
  errors: IFormError[]
}


const formDataSlice = createSlice({
  name: "formData",
  initialState: {
    responsibleAhks: [],
    userInfo: UserInfo.empty(),
    errors: []
  } as IFormDataState,

  reducers: {
    setFormData: (state, action: PayloadAction<IFormData>) => {
        state.responsibleAhks = action.payload.responsibleAhks;
        state.userInfo = action.payload.userInfo;
    },
    setErrors: (state, action: PayloadAction<IFormError[]>) => {
      state.errors = action.payload;
    },
  },
});

export const {
    setFormData,
    setErrors,
} = formDataSlice.actions;
export const selectFormData = (state: RootState) => state.formData;
export const formDataSliceReducer = formDataSlice.reducer;
